import postTaxonomyView from './postTaxonomyComponent.html';
import './postTaxonomyComponent.css';

export function postTaxonomyComponent() {
	return {
		bindings: {
			taxonomy: '<',
			onChange: '&',
		},
		controllerAs: 'vm',
		controller: postTaxonomyComponentCtrl,
		template: postTaxonomyView,
	};
}

export class postTaxonomyComponentCtrl {
	constructor(Api) {
		'ngInject';
		this.Api = Api;
	}

	$onInit() {
		if (this.taxonomy.type === 'autosuggest') {
			this.setupAutosuggest();
		}
		// official options are those approved for showing. They may be a set added by admins or, if allowed, they
		/// were added by other users when creating/editing the post.
		if (this.taxonomy.type === 'text') {
			this.taxonomy.text_input = this.taxonomy.text_input ? this.taxonomy.text_input : '';
			this.originalTextInput = this.taxonomy.text_input;
		} else {
			this.taxonomy.official_options = this.taxonomy.options.filter(option => option.is_official);
		}
	}

	/**
	 * Get details about the selected option for this taxonomy
	 * @returns Object|undefined  The option selected for the current taxonomy (based on DB records) or `undefined` if none selected.
	 */
	getSavedTaxonomyOption() {
		let savedOption;
		this.taxonomy.options.some(option => {
			if (option.selected) {
				savedOption = option;
				return true;
			}
		});

		return savedOption;
	}

	setupAutosuggest() {
		this.taxonomy.allSelected = this.taxonomy.options.filter(option => {
			option.$search = option.name;
			return option.selected;
		});
		this.maxAllowedResponsesOriginal = this.taxonomy.max_allowed_responses;
	}

	/**
	 * Called when user adds an item in the typeahead
	 */
	async onChooseSelected(option) {
		const selectedIdx = this.taxonomy.allSelected.length - 1;
		// can be `undefined` if the user erased a selected option
		const selected = this.taxonomy.allSelected[selectedIdx] || null;

		// if it's new, save it and get the id
		if (selected && selected.$new === true) {
			const resp = await this.Api.request('POST', `/taxonomies/${this.taxonomy.id}/options`, {
				option_name: selected.name,
			});
			// add the new id to the new item
			this.taxonomy.allSelected[selectedIdx].taxonomy_option_id = resp.headers('API-New-Record-Id') ?? resp.data.id;
		}

		// send on the ids of all selected options
		const selectedOptionIds = option.is_exclusive
			? [option.taxonomy_option_id]
			: this.taxonomy.allSelected.map(option => parseInt(option.taxonomy_option_id));

		//If is_exclusive, this is the only option you can pick so remove all other options
		if (option.is_exclusive) {
			this.taxonomy.allSelected = [option];
			this.taxonomy.max_allowed_responses = 1;
		}

		this.reportUpdates({ selectedOptionIds, selected });
	}

	/**
	 * Called when user removes an item in the typeahead
	 */
	onRemoveSelected(option) {
		// figure out which item was just added to the list of selected options
		const selectedIdx = this.taxonomy.allSelected.length - 1;
		// can be `undefined` if the user erased a selected option
		const selected = this.taxonomy.allSelected[selectedIdx] || null;

		// send on the ids of all selected options
		const selectedOptionIds = this.taxonomy.allSelected.map(option => parseInt(option.taxonomy_option_id));
		// If is_exclusive, the only option you can pick was removed
		// so set max_allowed_responses back to the original value
		if (option.is_exclusive) {
			this.taxonomy.max_allowed_responses = this.maxAllowedResponsesOriginal;
		}

		this.reportUpdates({ selectedOptionIds, selected });
	}

	async onTaxonomyInputBlurred(taxonomyInput) {
		//taxonomy is unchanged
		if (taxonomyInput.trim().toLowerCase() === this.originalTextInput.trim().toLowerCase()) {
			return;
		}
		const trimmedTaxonomyInput = taxonomyInput.trim();
		if (trimmedTaxonomyInput) {
			const resp = await this.Api.request('POST', `/taxonomies/${this.taxonomy.id}/options`, {
				option_name: taxonomyInput,
			});
			// add the new id to the new item;
			const newOptionId = parseInt(resp.headers('API-New-Record-Id'));
			if (newOptionId) {
				this.originalTextInput = taxonomyInput;
				const selectedOptionIds = [newOptionId];
				this.reportUpdates({ selectedOptionIds, selected: newOptionId });
			} else if (resp.status === 200 && resp.data?.id) {
				this.originalTextInput = taxonomyInput;
				const selectedOptionIds = [resp.data.id];
				this.reportUpdates({ selectedOptionIds, selected: resp.data.id });
			}
		} else {
			const selectedOptionIds = [null];
			this.reportUpdates({ selectedOptionIds, selected: null });
		}
	}

	/**
	 * Called when user selects a taxonomy option in <select>
	 * @param selectedOption Object|null  details about the `taxonomy_options` item selected for this taxonomy. `null` if the user chose the empty <option>.
	 */
	onSelectUpdated(selectedOption) {
		const selectedOptionIds = [selectedOption === null ? null : parseInt(selectedOption.taxonomy_option_id)];
		this.reportUpdates({ selectedOptionIds, selected: selectedOption });
	}

	/**
	 * Make the call to the callback, if any
	 * @param updates Object
	 * @property updates.selectedOptionIds Number[]  The list of `taxonomy_options.id` values selected (it will be only one for select-type items)
	 * @property updates.selected Object|null  details about the `taxonomy_options` item selected for this taxonomy. `null` if empty <option> selected or
	 */
	reportUpdates(updates) {
		this.onChange &&
			this.onChange({
				taxonomy: this.taxonomy,
				selectedOptionIds: updates.selectedOptionIds,
				selectedOption: updates.selected,
			});
	}
}
